'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _sentryCapture = require('@zz-common/sentry/lib/sentry-capture');

var _sentryCapture2 = _interopRequireDefault(_sentryCapture);

var _cookie2 = require('@zz-common/zz-utils/lib/cookie');

var _cookie3 = _interopRequireDefault(_cookie2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _circle = require('./circle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var _cookie$getPPU = _cookie3.default.getPPU(),
    TT = _cookie$getPPU.TT;

var RES_CODE_SUCCESS = [10001, 0]; // 接口返回成功状态码
var RES_CODE_UNLOGIN = [40001, -2]; // 接口返回未登陆状态码，未登陆/过期
var RES_CODE_LOGIN_UNAUTH = [40002]; // 接口返回未登陆状态码，未授权

_axios2.default.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

var catchError = function catchError(_ref) {
  var _ref$errType = _ref.errType,
      errType = _ref$errType === undefined ? 6 : _ref$errType,
      _ref$errorObj = _ref.errorObj,
      errorObj = _ref$errorObj === undefined ? '' : _ref$errorObj,
      _ref$respCode = _ref.respCode,
      respCode = _ref$respCode === undefined ? null : _ref$respCode,
      _ref$respData = _ref.respData,
      respData = _ref$respData === undefined ? {} : _ref$respData,
      _ref$params = _ref.params,
      params = _ref$params === undefined ? {} : _ref$params,
      _ref$apiUrl = _ref.apiUrl,
      apiUrl = _ref$apiUrl === undefined ? '' : _ref$apiUrl,
      _ref$apiTime = _ref.apiTime,
      apiTime = _ref$apiTime === undefined ? 0 : _ref$apiTime,
      _ref$loading = _ref.loading,
      loading = _ref$loading === undefined ? false : _ref$loading;

  if (loading) (0, _circle.removeLoadingObj)();
  // 异常主动上报
  (0, _sentryCapture2.default)(errorObj, errType, {
    tags: {
      apiUrl: '' + (apiUrl && apiUrl.split('?') && apiUrl.split('?')[0]),
      respCode: respCode,
      isbiz: !!(respCode && respCode > 10000)
    },
    extra: {
      apiUrl: apiUrl,
      response: respData,
      params: params,
      apiTime: apiTime
    }
  });
  if (_axios2.default.defaults.catchError) {
    _axios2.default.defaults.catchError({
      errType: errType,
      errorObj: errorObj,
      respCode: respCode,
      respData: respData,
      api: '' + (apiUrl && apiUrl.split('?') && apiUrl.split('?')[0]),
      params: params,
      apiUrl: apiUrl,
      apiTime: apiTime
    });
  }
};

var pendingAjax = []; // 避免重复的请求

function Buzz() {
  var reqObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _reqObj$method = reqObj.method,
      method = _reqObj$method === undefined ? 'get' : _reqObj$method,
      params = reqObj.params,
      data = reqObj.data,
      baseURL = reqObj.baseURL,
      timeout = reqObj.timeout,
      headers = reqObj.headers,
      withCredentials = reqObj.withCredentials,
      url = reqObj.url,
      file = reqObj.file,
      responseType = reqObj.responseType,
      _reqObj$needNewAxios = reqObj.needNewAxios,
      needNewAxios = _reqObj$needNewAxios === undefined ? false : _reqObj$needNewAxios,
      cancelToken = reqObj.cancelToken,
      transformRequest = reqObj.transformRequest,
      transformResponse = reqObj.transformResponse,
      _reqObj$needRespCode = reqObj.needRespCode,
      needRespCode = _reqObj$needRespCode === undefined ? false : _reqObj$needRespCode,
      _reqObj$needAllData = reqObj.needAllData,
      needAllData = _reqObj$needAllData === undefined ? false : _reqObj$needAllData,
      _reqObj$needGlobalTip = reqObj.needGlobalTips,
      needGlobalTips = _reqObj$needGlobalTip === undefined ? true : _reqObj$needGlobalTip,
      _reqObj$loading = reqObj.loading,
      loading = _reqObj$loading === undefined ? false : _reqObj$loading,
      _reqObj$throttle = reqObj.throttle,
      throttle = _reqObj$throttle === undefined ? false : _reqObj$throttle,
      _reqObj$loadingText = reqObj.loadingText,
      loadingText = _reqObj$loadingText === undefined ? '请求中...' : _reqObj$loadingText;

  var service = void 0;
  var defaultHeader = {
    'Content-Type': 'application/json'
  };
  if (TT) {
    defaultHeader['Csrf-Token'] = TT;
  }
  service = _axios2.default.create({
    baseURL: /^(http[s]?:)?\/\//.test(url) ? null : baseURL || _axios2.default.defaults.baseURL || '', // node环境的不同，对应不同的baseURL
    timeout: timeout || _axios2.default.defaults.timeout || 15000, // 请求的超时时间
    headers: (0, _extends3.default)(defaultHeader, headers),
    withCredentials: withCredentials || true // 允许携带cookie
  });

  var fastClickMsg = '数据请求中，请稍后';
  var CancelToken = _axios2.default.CancelToken;
  var removePendingAjax = function removePendingAjax(url, type) {
    var index = pendingAjax.findIndex(function (i) {
      return i.url === url;
    });
    if (index > -1) {
      type === 'req' && pendingAjax[index].callback(fastClickMsg);
      pendingAjax.splice(index, 1);
    }
  };

  var resCode = null;
  var allData = null;
  var errType = 6;
  var apiUrl = '';
  var respConfig = {};
  var startTime = new Date().getTime();
  var apiTime = 0;

  if (loading) (0, _circle.createLoadingObj)(loadingText);

  service.interceptors.request.use(function (config) {
    if (_axios2.default.defaults.beforeRequestFn) {
      // 默认请求前全局处理
      _axios2.default.defaults.beforeRequestFn(config);
    }
    respConfig = config;
    apiUrl = /^http[s]/.test(config.url) ? config.url : '' + config.baseURL + config.url;

    if (throttle) {
      removePendingAjax(url, 'req'); // 加入重复队列
      config.cancelToken = new CancelToken(function (callback) {
        pendingAjax.push({
          url: url,
          callback: callback
        });
      });
    }

    return config;
  }, function (error) {
    if (!apiTime) apiTime = new Date().getTime() - startTime;
    catchError({
      errType: 5,
      errorObj: error,
      respCode: resCode,
      respData: allData,
      apiUrl: apiUrl,
      apiTime: apiTime,
      loading: loading
    });
  });

  try {
    service.interceptors.response.use(function (resp) {
      if (loading) (0, _circle.removeLoadingObj)();
      if (throttle) removePendingAjax(resp.config.url, 'resp'); // 从防重复队列中移除
      var newResp = resp;
      apiUrl = resp.request.responseURL || apiUrl;
      var apiTime = new Date().getTime() - startTime;
      if (resp.status >= 300 || resp.status < 200) {
        // errType = 4;
        catchError({
          errType: 3,
          errorObj: '服务器开小差了',
          respCode: resp.status,
          respData: {
            respCode: resp.status,
            errorMsg: '服务器开小差了',
            from: 'server'
          },
          apiUrl: apiUrl,
          apiTime: apiTime
        });
        throw '服务器开小差了';
      } else {
        errType = 3;
      }
      var newData = newResp.data ? JSON.parse(newResp.data) : null;
      if (_axios2.default.defaults.beforeResponseFn) {
        // 默认请求后全局处理
        _axios2.default.defaults.beforeResponseFn(newData);
      }
      if (needAllData) {
        return newData;
      }
      if (!newData) return null;
      resCode = Number(newData.respCode);
      respConfig = resp.config;
      var method = respConfig.method;
      var errorInfo = newData.respMsg || newData.errorMsg || newData.errMsg;
      if (RES_CODE_SUCCESS.indexOf(resCode) < 0) {
        if (RES_CODE_UNLOGIN.indexOf(resCode) >= 0) {
          // 登录信息实效，跳转登录
          errorInfo = errorInfo || '请登录后重试';
          if (_axios2.default.defaults.noLoginUrl) {
            // 未登录跳转
            window.location.href = _axios2.default.defaults.noLoginUrl;
          }
        }
        if (RES_CODE_LOGIN_UNAUTH.indexOf(resCode) >= 0 && !needAllData) {
          // 未授权
          errorInfo = errorInfo || '未授权';
        }
        errorInfo = newData.respMsg || newData.errorMsg || newData.errMsg || '网络异常';
        var methodStatus = true;
        // if (method) {
        //   if (resCode > 10001 && resCode < 30000 && method.toLowerCase() === 'get' && !/\.zhuanspirit\.com/.test(apiUrl)) {
        //     methodStatus = false;
        //   }
        // }
        if (_axios2.default.defaults.globalTips && needGlobalTips && methodStatus) {
          _axios2.default.defaults.globalTips(errorInfo);
        }
        // 错误异常上报
        allData = newData;
        catchError({
          errType: errType,
          errorObj: errorInfo,
          respCode: resCode,
          respData: allData,
          params: method && method.toLowerCase() === 'get' ? respConfig.params : respConfig.data,
          apiUrl: apiUrl,
          apiTime: apiTime
        });
        if (needRespCode) {
          // 如果需要code
          newData.respMsg = errorInfo;
          newData.errorMsg = errorInfo;
          newData.errMsg = errorInfo;
          throw newData;
        } else {
          throw errorInfo;
        }
      } else {
        return newData && newData.respData;
      }
    }, function (error) {
      var method = respConfig.method;
      if (!apiTime) apiTime = new Date().getTime() - startTime;
      catchError({
        errType: 5,
        errorObj: error,
        respCode: resCode,
        respData: allData,
        params: method && method.toLowerCase() === 'get' ? respConfig.params : respConfig.data,
        apiUrl: apiUrl,
        apiTime: apiTime
      });
    });
  } catch (e) {
    console.warn('WARNING: response fail');
  }

  if (needNewAxios) {
    return _axios2.default;
  }
  var newPostData = data; // 兼容params传进来，但请求方式是post，同时处理成JSON字符串
  if (method && method.toLowerCase() === 'post' && params) {
    if ((typeof params === 'undefined' ? 'undefined' : (0, _typeof3.default)(params)) === "object") {
      newPostData = (0, _stringify2.default)(params);
    } else {
      newPostData = params;
    }
  }
  var newUrl = url;
  if (method && method.toLowerCase() === 'get' && params && (0, _keys2.default)(params).length) {
    var paramsEncode = (0, _keys2.default)(params).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    newUrl = '' + url + (url.indexOf('?') > 0 ? '&' : '?') + paramsEncode;
  }
  return service({
    method: method,
    url: newUrl,
    data: file || newPostData, // 优先上传file
    responseType: responseType,
    // params: (method && method.toLowerCase() === 'post') ? '' : params, // 请求方式是post的时候，param处理为空
    cancelToken: cancelToken,
    transformRequest: transformRequest,
    transformResponse: transformResponse
  });
}

exports.default = Buzz;

/**
 * @function
 * @name Buzz - 请求基础核心方法
 * @desc 为商业FE准备的axios再包装，提供了一些针对业务的方法，依赖于axios
 * @param {string} url 请求地址
 * @param {object} [needGlobalTips] `needGlobalTips` 传入false时，不弹出全局提示
 * @param {boolean} [needRespCode] 是否需要所有的返回码，默认false
 * @param {object} [params] `params` 是即将与请求一起发送的 URL 参数，必须是一个无格式对象(plain object)或 URLSearchParams 对象
 * @param {number} [timeout] 请求超时时间，默认是5000，也可以在默认设置中就配置好
 * @param {boolean} [loading] 是否显示接口loading状态
 * @param {string} [method] 请求方式，默认是get
 * @param {string} [baseURL] 请求的基础地址，如：//app.zhuanzhuan.com（默认）
 * @param {string} [headers] post请求头设置，也可以在默认设置中就配置好，如：application/json（默认）
 * @param {boolean} [withCredentials] 是否携带cookie，默认携带
 * @param {boolean} [needAllData] 是否需要返回所有的数据，默认false
 * @param {boolean} [throttle] 是否需要开启请求节流，默认true
 * @param {function} [transformRequest] 在请求之前的参数处理
 * @param {function} [transformResponse] 在请求之后的参数处理
 * @param {boolean} [needNewAxios] 是否需要一个新axios对象，用于buzz包无法满足使用需求的情况下，直接直返axios对象
 * @param {string} [responseType] 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream', 'json'（默认）
 * @param {object} [cancelToken] `cancelToken` 指定用于取消请求的 cancel token，详情请查看axios的中文文档
 * @example
 * import { Buzz } from '@zz-biz/request';
 * // 示例1
 * Buzz({ // 传入一个配置对象进行调用，默认请求方式为get
 *  url: '/biz/user/gettaglist'
 * }).then(res => {
 *  console.log(res);
 * });
 */

module.exports = exports['default'];